const STORAGE_KEY = 'subscription_payment_inflight';

export type SubscriptionPaymentInflight = {
  ts: number;
  cid: number;
  sid: number;
};

type InflightStorage = Pick<Storage, 'getItem' | 'setItem'>;

export const readSubscriptionPaymentInflight = (
  storage: InflightStorage = window.localStorage,
): SubscriptionPaymentInflight | null => {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SubscriptionPaymentInflight;
    return parsed &&
      Number.isFinite(parsed.ts) &&
      Number.isInteger(parsed.cid) &&
      parsed.cid > 0 &&
      Number.isInteger(parsed.sid) &&
      parsed.sid > 0
      ? parsed
      : null;
  } catch {
    return null;
  }
};

export const saveSubscriptionPaymentInflight = (
  inflight: SubscriptionPaymentInflight,
  storage: InflightStorage = window.localStorage,
) => {
  storage.setItem(STORAGE_KEY, JSON.stringify(inflight));
};

export const isSubscriptionPaymentInflightFor = (
  inflight: SubscriptionPaymentInflight | null,
  customerId: number,
  subscriptionId: number,
): boolean => inflight?.cid === customerId && inflight.sid === subscriptionId;

export const resolveSubscriptionPaymentRestoration = (
  customerId: number,
  propSubscriptionId: number | undefined,
  inflight: SubscriptionPaymentInflight | null,
): { subscriptionId: number | undefined; missingAffiliateContext: boolean } => {
  if (propSubscriptionId) {
    return {
      subscriptionId: propSubscriptionId,
      missingAffiliateContext: false,
    };
  }
  if (!inflight || inflight.cid !== customerId) {
    return { subscriptionId: undefined, missingAffiliateContext: false };
  }
  // 決済先は取得した契約の法人IDで確定するため、端末内の法人記録は不要。
  return { subscriptionId: inflight.sid, missingAffiliateContext: false };
};
